import { Table, Text, Avatar, HStack, Box } from '@chakra-ui/react';
import type { DailyCanvasserStatsDto } from '../../../types/campaign'
import { AuthedAvatarImage } from '../../shared'

interface Props {
  canvasserStats: DailyCanvasserStatsDto[]
}

function formatDistance(meters: number | null): string {
  if (meters == null) return '—'
  if (meters < 1000) return `${Math.round(meters)} m`
  const miles = meters / 1609.34
  return `${miles.toFixed(1)} mi`
}

export function CanvasserStatsTable({ canvasserStats }: Props) {
  if (canvasserStats.length === 0) {
    return (
      <Box p={4} bg="gray.50" borderRadius="md" textAlign="center">
        <Text color="gray.500" fontSize="sm">No canvasser activity for this date</Text>
      </Box>
    )
  }

  const hasBusinesses = canvasserStats.some(c => c.businessesVisited > 0)
  const hasDoors = canvasserStats.some(c => c.doorsKnocked > 0)
  // Show doors column unless all activity is business-only
  const showDoors = hasDoors || !hasBusinesses

  return (
    <Table.Root size="sm">
      <Table.Header bg="gray.50">
        <Table.Row>
          <Table.ColumnHeader>Canvasser</Table.ColumnHeader>
          {showDoors && <Table.ColumnHeader textAlign='end'>Doors</Table.ColumnHeader>}
          {hasBusinesses && <Table.ColumnHeader textAlign='end'>Businesses</Table.ColumnHeader>}
          <Table.ColumnHeader textAlign='end'>Contacts</Table.ColumnHeader>
          <Table.ColumnHeader textAlign='end'>Distance</Table.ColumnHeader>
          <Table.ColumnHeader textAlign='end'>Avg/Stop</Table.ColumnHeader>
          <Table.ColumnHeader textAlign='end'>Turfs</Table.ColumnHeader>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {canvasserStats.map((c) => (
          <Table.Row key={c.grantId}>
            <Table.Cell>
              <HStack gap={2}>
                <Avatar.Root size="xs"><Avatar.Fallback name={c.fullName} /><AuthedAvatarImage src={c.portraitUrl} /></Avatar.Root>
                <Text fontSize="sm" fontWeight="medium">{c.fullName}</Text>
              </HStack>
            </Table.Cell>
            {showDoors && (
              <Table.Cell textAlign='end'>
                <Text fontSize="sm" fontWeight="bold">{c.doorsKnocked}</Text>
              </Table.Cell>
            )}
            {hasBusinesses && (
              <Table.Cell textAlign='end'>
                <Text fontSize="sm" fontWeight="bold">{c.businessesVisited}</Text>
              </Table.Cell>
            )}
            <Table.Cell textAlign='end'>
              <Text fontSize="sm">{c.contactsMade}</Text>
            </Table.Cell>
            <Table.Cell textAlign='end'>
              <Text fontSize="sm">{formatDistance(c.distanceWalkedMeters)}</Text>
            </Table.Cell>
            <Table.Cell textAlign='end'>
              <Text fontSize="sm">{formatDistance(c.avgDistanceBetweenStopsMeters)}</Text>
            </Table.Cell>
            <Table.Cell textAlign='end'>
              <Text fontSize="sm">{c.turfsWorked}</Text>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Root>
  );
}
